import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function ManageOrder() {

  const orders = [
    {
      id: 1,
      client: "Ravi Kumar",
      contact: "9876543210",
      address: "Delhi",
      date:"15/04/2026",
      services: [
        { name: "Hair Cut", price: 300, time: "30 min" },
        { name: "Beard Trim", price: 200, time: "15 min" }
      ],
      payment: { subtotal: 500, gst: 90, total: 590 }
    },
    {
      id: 2,
      client: "Amit Sharma",
      contact: "9123456780",
      address: "Noida",
       date:"13/04/2026",
      services: [
        { name: "Facial", price: 800, time: "45 min" }
      ],
      payment: { subtotal: 800, gst: 144, total: 944 }
    }
  ];

  const [search, setSearch] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();

  const filtered = orders.filter(o =>
    o.client.toLowerCase().includes(search.toLowerCase())
  );

  return (
   <div className="container-fluid mt-3">

  <h2 className="text-white mb-4">Order List</h2>

 
  <div
    className="p-4 rounded-4"
    style={{
      backgroundColor: "var(--black)",
      border: "1px solid #2d3748"
    }}
  >

<div className="d-flex justify-content-between align-items-center mb-4">


  <input
    type="text"
    className="form-control  text-white border-secondary"
    placeholder="Search 100 records..."
    style={{ width: "280px" }}  
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />

  <select
    className="form-select bg-dark text-white border-secondary"
    style={{ width: "200px" }}  
  >
    <option>All Orders</option>
    <option>High Value</option>
    <option>Low Value</option>
  </select>

</div>


  <div className="table-responsive border border-secondary">
  <table
    className="table table-hover align-middle mb-0"
  
  >

  
    <thead>
      <tr className="p-3">
        <th className="px-4 py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>SN</th>
        <th  className="px-4 py-3"  style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Customer Name</th>
        <th className="px-4 py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Contact</th>
          <th  className="px-4 py-3"style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Status</th>
                    <th className="px-4 py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Date</th>
        <th className="px-4 py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Action</th>
      </tr>
    </thead>

    {/* BODY */}
    <tbody>
      {filtered.map((order, index) => (
        <tr
          key={order.id}
          style={{
            borderBottom: "1px solid #505459",
            transition: "0.2s"
          }}
        
        >
          <td className="px-4 py-3" style={{ backgroundColor: "var(--black)", color: "#fff" }} >{index + 1}</td>

          <td className="px-4 py-3" style={{ backgroundColor: "var(--black)", color: "#fff" }}>
          {order.client}
          </td>

          <td className="px-4 py-3" style={{ backgroundColor: "var(--black)", color: "#fff" }}>{order.contact}</td>
                    <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>Confirmed</td>
                       <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>{order.date} </td>
          <td className="px-4 py-3" style={{ backgroundColor: "var(--black)", color: "#fff" }}>
            <button
              className="btn btn-sm"
              style={{
                backgroundColor: "transparent",
                border: "1px solid #3b82f6",
                color: "#3b82f6",
                borderRadius: "6px",
                padding: "4px 10px"
              }}
            onClick={() => navigate("/admin/order-detail", { state: order })}
            >
              View
            </button>
          </td>
        </tr>
      ))}
    </tbody>

  </table>
</div>

  </div>


  {selectedOrder && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
      }}
    >
      <div
        className="p-4 rounded-4"
        style={{
          width: "500px",
          backgroundColor: "#1e293b",
          border: "1px solid #2d3748"
        }}
      >
        <h5 className="text-white mb-3">
          {selectedOrder.client} Details
        </h5>

        <h6 className="text-info">Services</h6>
        {selectedOrder.services.map((srv, i) => (
          <div key={i} className="d-flex justify-content-between text-white mb-2">
            <span>{srv.name} ({srv.time})</span>
            <span>₹ {srv.price}</span>
          </div>
        ))}

        <hr style={{ borderColor: "#334155" }} />

        <h6 className="text-info">Payment</h6>
        <div className="d-flex justify-content-between text-white">
          <span>Subtotal</span>
          <span>₹ {selectedOrder.payment.subtotal}</span>
        </div>
        <div className="d-flex justify-content-between text-white">
          <span>GST</span>
          <span>₹ {selectedOrder.payment.gst}</span>
        </div>
        <div className="d-flex justify-content-between text-white fw-bold">
          <span>Total</span>
          <span>₹ {selectedOrder.payment.total}</span>
        </div>

        <div className="text-end mt-3">
          <button
            className="btn btn-secondary"
            onClick={() => setSelectedOrder(null)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )}

</div>
  );
}

export default ManageOrder;